import { Asset } from "../Asset";
export class Rectangle extends Asset {
    constructor(width, height, color, options) {
        super();
        this.width = width;
        this.height = height;
        this.color = color;
        this.options = options;
    }
    draw(ctx, owner, options) {
        if (!options)
            options = this.options;
        ctx.fillStyle = this.color;
        let x = owner.position.getX();
        let y = owner.position.getY();
        if (options) {
            if (options.positioning) {
                if (options.positioning === 'center') {
                    x -= this.width / 2;
                    y += this.height / 2;
                }
                if (options.positioning === 'right') {
                    x -= this.width;
                    y += this.height;
                }
            }
            else if (options.positioningX) {
                if (options.positioningX === 'center') {
                    x -= this.width / 2;
                }
                if (options.positioningX === 'right') {
                    x -= this.width;
                }
            }
        }
        ctx.fillRect(x, y, this.width, this.height);
    }
}
//# sourceMappingURL=Rectangle.js.map